import { url } from "../config";

const responseChecker = (type, action, id) => {
  console.log(id);
  switch (type) {
    case "LINK":
      window.open(action.link, "_self");
      break;
    case "VIDEO":
      window.open(`${url}${action.video}`, "_self");
      break;
    case "EMPTY":
      window.open(`${url}/products/${id}/edit`, "_self");
      break;
    default:
      return null;
  }
};

export { responseChecker };
